import { UPDATE_PAGE_NEXT_PAGE, UPDATE_FILTER_NAME } from './types'
import { COMPETITIONS_WON } from '../global/enums'

const wonCompState = {
    project_name: '',
    type: COMPETITIONS_WON,
    limit: 20,
    page: 1,
    nextPage: null
}

const wonCompReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {
        case UPDATE_PAGE_NEXT_PAGE: {
            return {
              ...state,
              page: payload.page,
              nextPage: payload.nextPage
            }
        }
        case UPDATE_FILTER_NAME: {
          return {
              ...state,
              project_name: payload,
          }
        }
        default: {
          return state
        }
    }

}

export { wonCompReducer as default, wonCompState }